import { render } from "./dialog-seat-details.vue?vue&type=template&id=0d120370&scoped=true&ts=true"
import script from "./dialog-seat-details.vue?vue&type=script&lang=ts"
export * from "./dialog-seat-details.vue?vue&type=script&lang=ts"

import "./dialog-seat-details.vue?vue&type=style&index=0&id=0d120370&lang=stylus&scoped=true"

import exportComponent from "/Users/rong.chen/data/zd/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d120370"]])

export default __exports__